import { inject, Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { environment } from '@environments/environment'
import { CertificateApiResponse } from '@features/certificate/models/certificate-general-info/certificate-general-info.model'

@Injectable({
  providedIn: 'root'
})
export class CertificateGeneralInfoService {
  private readonly http = inject(HttpClient)
  private readonly apiUrl = environment.certificateApiUrl

  public getById(uuid: string): Observable<CertificateApiResponse> {
    return this.http.get<CertificateApiResponse>(`${this.apiUrl}/${uuid}`)
  }

  public create(data: CertificateApiResponse): Observable<CertificateApiResponse> {
    return this.http.post<CertificateApiResponse>(this.apiUrl, data)
  }

  public update(data: CertificateApiResponse): Observable<CertificateApiResponse> {
    return this.http.put<CertificateApiResponse>(this.apiUrl, data)
  }

  public save(data: CertificateApiResponse): Observable<CertificateApiResponse> {
    const uuidValue = data.uuid

    const hasUuid = uuidValue !== null &&
      uuidValue !== undefined
    return hasUuid
      ? this.update(data)
      : this.create(data)
  }
}
